import { Message } from "@JohnLewisPartnership/jl-design-system/dist/components/message/Message";

export type Props = {
  deliveryCost: string;
};

export const SupplierDirectDeliveryMessageUI = ({ deliveryCost }: Props) => {
  const ukDeliveryCost = parseInt(deliveryCost) ?? 0;
  const deliveryTitle = `${
    ukDeliveryCost > 0 ? "" : "Free "
  }UK delivery direct from our supplier`;

  return (
    <Message
      type="information"
      dataTestId="supplier:direct-delivery-message"
      title={deliveryTitle}
      body={"You will be contacted to arrange a date and time for delivery."}
      containerProps={{ ["data-component"]: "SupplierDirectDeliveryMessage" }}
    />
  );
};
